import { useEffect, useState } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

export default function ContentPage() {
  const { slug } = useParams()
  const [page, setPage] = useState(undefined)
  useEffect(() => {
    fetch(`/admin/api/public/content/${encodeURIComponent(slug)}`)
      .then(response => response.ok ? response.json() : null).then(setPage).catch(() => setPage(null))
  }, [slug])
  if (page === undefined) return <div className="py-16 text-center text-muted-foreground">Loading…</div>
  if (!page) return <Navigate to="/404" replace />
  return <article id="main-content" className="prose prose-sm sm:prose-base dark:prose-invert max-w-4xl mx-auto px-4 py-12">
    <Helmet>
      <title>{page.seoTitle || page.title}</title>
      {page.metaDescription && <meta name="description" content={page.metaDescription} />}
      {page.canonical && <link rel="canonical" href={page.canonical} />}
    </Helmet>
    <h1>{page.title}</h1>
    <div dangerouslySetInnerHTML={{ __html: page.content }} />
  </article>
}